
import { Component, Mixins } from "vue-property-decorator";
import { IObjectsControllable, ILinkedPageObjectSpecifiable } from "../../../../../../documaker/domain/format/objects";
import { IScriptExecuteTriggerBehaviorPropertyEditable, instanceOfIScriptExecuteTriggerBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class ScriptExecuteTriggerBehaviorPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IScriptExecuteTriggerBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IScriptExecuteTriggerBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isScriptExecuteTriggerBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIScriptExecuteTriggerBehaviorPropertyEditable(s) && s.scriptExecuteTriggerBehavior().isEditable(), false);
  }

  get scriptExecuteTriggerBehavior(): IObjectsControllable<ILinkedPageObjectSpecifiable> {
    return this.readPropertyOrDefault(s => s.scriptExecuteTriggerBehavior().getValue(), { targets: [] });
  }

  set scriptExecuteTriggerBehavior(value: IObjectsControllable<ILinkedPageObjectSpecifiable>) {
    this.writePropertyWhenValid(s => s.scriptExecuteTriggerBehavior().setValue(value));
  }
}
